<template>
  <div class="game-container">
    <model-obj
      :rotation="rotation"
      src="static/Games/page000_testModel3d01/img/heart.obj"
      mtl="static/Games/page000_testModel3d01/img/heart.mtl"
    ></model-obj>
  </div>
</template>

<script>
import _ from 'lodash';
import * as utils from '../../Utils/inputUtils';
import { ModelObj } from 'vue-3d-model';
export default {
  name: 'mp-model-show',
  components: { ModelObj },
  props: {
    startGameConfig: {
      type: Object,
      default: function() {
        return {};
      },
    },
  },
  data() {
    return {
      rotation: {
        x: 0,
        y: 0,
        z: 0,
      },
    };
  },
  beforeMount() {
    this.init();
  },
  mounted() {},
  methods: {
    init() {
      this.rotate();
    },
    rotate() {
      this.rotation.y += 0.01;
      requestAnimationFrame(this.rotate);
    },
    resetGameAction() {},
    checkGameAction() {},
  },
  computed: {},
};
</script>

<style lang="scss" scoped>
.game-container {
  display: flex;
  padding-top: 200px;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  width: 100%;
  height: 100%;
}
</style>
